<template>
    <div>
        <el-card>
            <div class="boxClass">
                <span>特殊统计</span>
                <div>
                    <router-link :to="{ path: '/mannerAndComplane'}">
                        <span>服务态度 & 用户投诉</span>
                    </router-link>
                    <router-link :to="{ path: '/serviceDesk'}">
                        <span>服务台人员统计</span>
                    </router-link>
                    <!-- <router-link :to="{ path: '/knowledgeOne'}">
                        <span>知识库统计01</span>
                    </router-link> -->
                    <router-link :to="{ path: '/knowledgeTwo'}">
                        <span>知识库统计</span>
                    </router-link>
                    <router-link :to="{ path: '/saleMoney'}">
                        <span>销售额统计</span>
                    </router-link>
                    <router-link :to="{ path: '/serviceLevel'}">
                        <span>服务级别管理SLA统计</span>
                    </router-link>
                    <router-link :to="{ path: '/eventManageBar'}">
                        <span>事件管理统计</span>
                    </router-link>
                    <router-link :to="{ path: '/accidentStaticPie'}">
                        <span>事故统计</span>
                    </router-link>
                    <router-link :to="{ path: '/questionManageBar'}">
                        <span>问题管理</span>
                    </router-link>
                    <!-- <router-link :to="{ path: '/configManagePie'}">
                        <span>配置管理</span>
                    </router-link> -->
                    <router-link :to="{ path: '/changeManageBar'}">
                        <span>变更管理</span>
                    </router-link>
                    <router-link :to="{ path: '/publishManageBar'}">
                        <span>发布管理</span>
                    </router-link>
                </div>
                
            </div>
        </el-card>
    </div>
</template>

<script>
    
    export default {
        
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .boxClass{
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        &>span{
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 10px;
        }
        &>div{
            display: flex;
            flex-wrap:wrap;
            span{
                color:gray!important;
                margin-right: 30px;
            }
        }
    }
</style>

